import { useQuery } from "@tanstack/react-query";
import { getRoutineRepUnits, getRoutineWeightUnits } from "@/components/Routines/api/workoutUnits";
import { QueryKey, } from "@/core/lib/consts";


export const useFetchRoutineWeighUnitsQuery = () => useQuery({
    queryKey: [QueryKey.ROUTINE_WEIGHT_UNITS],
    queryFn: getRoutineWeightUnits
});

export const useFetchRoutineRepUnitsQuery = () => useQuery({
    queryKey: [QueryKey.ROUTINE_REP_UNITS],
    queryFn: getRoutineRepUnits
});

